import { render, staticRenderFns } from "./ServiceBundleInfo.vue?vue&type=template&id=66d0b28a&"
import script from "./ServiceBundleInfo.vue?vue&type=script&lang=js&"
export * from "./ServiceBundleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports